import React, { memo } from 'react';
import classnames from 'classnames';
import Loading from '@gp/components/Loading';
import Filter from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Projects/Details/components/Live/components/Filter';
import Breakdown from './components/Breakdown';
import TotalReveeueTrends from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Projects/Details/components/Live/components/TotalRevenueTrends';
import usePageLog from '@gp/hooks/usePageLog';
import useLive from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Projects/Details/components/Live/hooks/useLive';
import '@gp/pages/StudioDashboard/StudioOverall/Tabs/Projects/Details/components/Live/index.scss';

interface ILiveProps extends IBaseProps {
  studioId: string;
}

const Live: React.FC<ILiveProps> = (props) => {
  const {
    studioId,
    style,
    className,
    isLoading,
    projectFilterLoading,
    projects,
    sources,
    formModel,
    selectedProjects,
    ...remains
  } = props;

  // const {
  //   isLoading,
  //   projectFilterLoading,
  //   projects,
  //   sources,
  //   formModel,
  //   selectedProjects,
  //   handleFilterChange,
  // } = useLive(studioId);

  // usePageLog({
  //   pageId: 'STUDIO_OVERALL_DETAILS_PROJECTS_LIVE',
  //   uidType: 'studio_id',
  //   uid: studioId || '',
  // });

  /* if (isLoading)
    return (
      <Loading
        style={{ position: 'unset' }}
        innerStyle={{ height: 'calc(100% - 74px)', top: 74 }}
        loading
        loadingBg="#f2f3f5"
      />
    ); */

  return (
    <div
      {...remains}
      style={style}
      className={classnames('dbg-studio-overall-details-projects-live', className)}
    >
      <TotalReveeueTrends
        studioId={studioId}
        projects={projects}
        selectedProjects={selectedProjects}
        formModel={formModel}
        projectFilterLoading={projectFilterLoading}
      />
      <Breakdown
        studioId={studioId}
        formModel={formModel}
        selectedProjects={selectedProjects}
        projectFilterLoading={projectFilterLoading}
      />
    </div>
  );
};

export default memo(Live);
